export default "__VITE_ASSET__oTxQV0H8__"